module.exports = __webpack_public_path__ + "images/grabbing---66f63f272cf0a70b26d5f06b42cabe7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/vendor/style/owl.carousel/grabbing.png
// module id = 401
// module chunks = 0